import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import RuleBasedAI from './components/RuleBasedAI';
import AIVoiceCall from './components/AIVoiceCall';
import CustomCursor from './components/CustomCursor';
import AnimatedBackground from './components/AnimatedBackground';
import Home from './pages/Home';
import Services from './pages/Services';
import Projects from './pages/Projects';
import About from './pages/About';
import Contact from './pages/Contact';
import VoiceChat from './pages/VoiceChat';
import './index.css';
import DarkGlowTracker from './components/DarkGlowTracker';
import { useEffect } from 'react';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <DarkGlowTracker/>
      <CustomCursor />
      <AnimatedBackground />
      <Navbar />
      <main style={{ position: 'relative', zIndex: 1 }}>
        <Routes>
          <Route path="/"           element={<Home />} />
          <Route path="/services"   element={<Services />} />
          <Route path="/projects"   element={<Projects />} />
          <Route path="/about"      element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/voice-chat" element={<VoiceChat />} />
        </Routes>
      </main>
      <Footer />
      <RuleBasedAI />
      <AIVoiceCall />
    </>
  );
}